import { Col, Row } from "antd";
import React from "react";

export const InlineForm = React.memo(
  ({
    children,
    gutter = [24, 16],
    wrap = true,
  }: {
    children: React.ReactNode;
    gutter?: [number, number];
    wrap?: boolean;
  }) => {
    const items = React.Children.toArray(children);

    return (
      <Row gutter={gutter} wrap={wrap}>
        {items.map((child, index) => (
          <Col key={index} flex="1">
            {child}
          </Col>
        ))}
      </Row>
    );
  },
);
